import React from 'react';
import { CONFIG } from 'config/config';
import CercleArrow from 'assets/images/svgDynamic/CercleArrow';
import SimpleArrow from 'assets/images/svgDynamic/SimpleArrow';



export const BackNextButtonIcon = ({
	hasIcon,
	variant,
	iconColor = CONFIG.components.backNextButton.icon.color,
}) => {
	const style = {
		height: CONFIG.components.backNextButton.icon.size.height,
		width: CONFIG.components.backNextButton.icon.size.width,
		marginRight: variant === 'left' ? CONFIG.components.backNextButton.icon.margin : 0,
		marginLeft: variant === 'left' ? 0 : CONFIG.components.backNextButton.icon.margin,
	};

	return hasIcon && CONFIG.components.backNextButton.icon.variant === 'simpleArrow' ? (
		<SimpleArrow variant={variant} color={iconColor} style={style} />
	) : CONFIG.components.backNextButton.icon.variant === 'cercleArrow' ? (
		<CercleArrow variant={variant} color={iconColor} style={style} />
	) : null;
};
